import React from "react";
import { Box, Typography } from "@mui/material";
import director from "../img/director.png";
import invert from "../img/icon/invert.png";
import "../../styles/components-styles/DirectorMessage.css";
function DirectorMessage() {
  return (
    <Box className="director-container">
      {/* Title */}
      <Typography className="director-title">Director’s Message</Typography>

      {/* Content Container */}
      <Box className="director-content">
        {/* Image Section */}
        <Box className="director-image-container">
          <Box className="director-image">
            <img src={director} alt="Director" />
          </Box>
        </Box>

        {/* Text Section */}
        <Box className="director-text">
          {/* Director's Name and Quote */}
          <Box className="director-stff">
            <Typography className="director-name">
              - Mr. Hrishikesh Shelke{" "}
              <Typography component="span" className="director-degree">
                M.Sc
              </Typography>
            </Typography>
            <Box style={{ marginTop: "4.5vh" }}>
              <img src={invert} alt="" />
              <Box
                className="quote-class"
                style={{ width: "38vw", height: "98px", marginLeft: "4.9vw" }}
              >
                <Typography component="span" className="director-quote">
                  "Education is the manifestation of perfection already in man."
                </Typography>
                <Typography className="director-quote-author">
                  - Swami Vivekananda
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Paragraph Content */}
          <Typography className="director-message">
            " At{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              Hrishi’s Holistic Hub
            </strong>
            , we believe that education is the foundation for transformation—not
            just in academics, but in character, values, and the ability to
            shape a better world. Our vision has always been to create a{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              nurturing, dynamic, and inspiring
            </strong>{" "}
            learning space where students can{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              explore, innovate, and grow
            </strong>{" "}
            into confident individuals ready to make a meaningful impact. We
            firmly believe that today’s youth has the{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              potential to lead change
            </strong>
            , and it is our mission to{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              empower them with knowledge, skills, and values
            </strong>{" "}
            that go beyond textbooks. Our holistic approach ensures that
            students excel not just in academics but also in{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              arts, leadership, and problem-solving
            </strong>
            , helping them develop into{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              well-rounded individuals
            </strong>
            . At{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              Hrishi’s Holistic Hub
            </strong>
            , our team of{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              dedicated educators
            </strong>{" "}
            plays a crucial role in mentoring and guiding students, ensuring
            that each child receives{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              individual attention
            </strong>{" "}
            and the opportunity to unlock their full potential. We take pride in
            fostering an{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              inclusive, engaging, and forward-thinking
            </strong>{" "}
            learning environment where creativity, critical thinking, and
            resilience are nurtured. In these{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              rapidly evolving times
            </strong>
            , education must adapt and grow. We remain committed to{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              innovative teaching methodologies, engaging workshops, and
              continuous professional development
            </strong>{" "}
            for our staff to ensure that our students are always at the
            forefront of learning advancements. Parents are an{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              integral part of our journey
            </strong>
            , and we deeply value the trust and collaboration they bring.
            Together, as{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              students, teachers, and parents
            </strong>
            , we form a strong, supportive community where learning thrives. As
            we move forward, let us continue to instill in our children the{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              courage to dream, the passion to pursue their goals, and the
              resilience to overcome challenges
            </strong>
            . With dedication and perseverance, we can shape a future where
            education is not just about learning—it is about{" "}
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              transforming lives
            </strong>
            .
            <strong style={{ fontFamily: "Kumbh Sans" }}>
              Hrishi's Holistic Hub—
            </strong>
            where learning is a journey, not just a destination. "
          </Typography>

          <Box className="director-footer">
            <img src={invert} alt="" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default DirectorMessage;
